import React, { useState, useEffect } from 'react';
import { getStaticProps as getStaticPropsMethod } from '@/bit/pages/pages.create-pages';
import { getClientType } from '@/utils/common';
import { wrapper } from 'store';
import LMClientForm from '@/forms/client/gp/lm';
import LMNoClientForm from '@/forms/noClient/gp/lm';
import { CLIENT_TYPE } from '@/constants/constant';
import { PATH_NAME, URL_SEO } from '@/constants/pages/mobileLines';
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';
import MetaData from '@/bit/core/core.meta-data';
import Saam from '@/bit/core/core.scripts.saam';

const LM = ({ seoInfo }) => {
  const [clientType, setClientType] = useState('');

  useEffect(() => {
    const clientStatus = getClientType();
    if (clientStatus === CLIENT_TYPE.CLIENT) {
      setClientType(CLIENT_TYPE.CLIENT);
    } else if (clientStatus === CLIENT_TYPE.SOFT_CLIENT) {
      sendToRelogin();
    } else {
      setClientType(CLIENT_TYPE.NO_CLIENT);
    }
  }, []);
  return (
    <>
      <Saam />
      <MetaData seoInfo={seoInfo} />
      {clientType && clientType === CLIENT_TYPE.CLIENT && <LMClientForm />}
      {clientType && clientType === CLIENT_TYPE.NO_CLIENT && <LMNoClientForm />}
    </>
  );
};
export default LM;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, '', 2, {
    pathname: PATH_NAME.GP,
    orionAlias: '',
    seoLocation: URL_SEO.GP,
    headerLocation: '/',
    layoutInfo: '',
  });
});
